import React from 'react';
import MasterLayout from '../../masterLayout/MasterLayout';
import Breadcrumb from '../Breadcrumb';
import { AppAlert, AppPagination } from '../ui';
import { AppFilterBar } from '../filters';
import KkpPlanningPageActions from './KkpPlanningPageActions';
import KkpPlanningViewModeSwitch from './KkpPlanningViewModeSwitch';
import KkpPlanningEmptyState from './KkpPlanningEmptyState';
import '../../styles/kkp-planning-page.scss';

/**
 * Coquille commune des plannings ventes (toolbar, filtres, résultats, pagination).
 * Le contenu tableau et les modals restent dans la page canal.
 */
const KkpPlanningPageShell = ({
  title,
  subtitle,
  pageActions = null,
  menuItems = [],
  actions = [],
  error = null,
  banners = null,
  kpi = null,
  fileInputRef = null,
  onImportFile = null,
  resetDisabled = false,
  onResetFilters,
  filterChildren = null,
  viewMode,
  onViewModeChange,
  viewModeCounts = null,
  onCreate = null,
  resultsCardClassName = '',
  loading = false,
  table = null,
  pagination = null,
  onPageChange = null,
  totalLabel = null,
  modals = null,
}) => (
  <MasterLayout>
    <Breadcrumb
      title={title}
      subtitle={subtitle}
      actions={
        pageActions ?? (
          <KkpPlanningPageActions actions={actions} menuItems={menuItems} />
        )
      }
    />

    {error ? <AppAlert>{error}</AppAlert> : null}

    {fileInputRef ? (
      <input
        ref={fileInputRef}
        type="file"
        accept=".xlsx,.xls,.xlsm,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
        className="d-none"
        onChange={onImportFile}
      />
    ) : null}

    <AppFilterBar resetDisabled={resetDisabled} onReset={onResetFilters}>
      {filterChildren}
    </AppFilterBar>

    {banners}
    {kpi}

    <div className={`card kkp-planning-results-card${resultsCardClassName ? ` ${resultsCardClassName}` : ''}`}>
      <KkpPlanningViewModeSwitch
        value={viewMode}
        onChange={onViewModeChange}
        counts={viewModeCounts}
        onCreate={onCreate}
      />
      <div className="card-body p-0">
        {loading ? (
          <KkpPlanningEmptyState loading />
        ) : (
          table
        )}
      </div>
      {pagination?.total > 0 && onPageChange ? (
        <div className="card-footer">
          <AppPagination
            variant="simple"
            pagination={pagination}
            totalLabel={totalLabel ?? `${pagination.total} vente(s)`}
            onPageChange={onPageChange}
          />
        </div>
      ) : null}
    </div>

    {modals}
  </MasterLayout>
);

/**
 * Ligne empty state à placer dans un tbody quand empty && !loading.
 */
export const KkpPlanningEmptyRow = ({
  colSpan = 8,
  message,
  actions = [],
}) => (
  <tr>
    <td colSpan={colSpan} className="p-0">
      <KkpPlanningEmptyState message={message} actions={actions} />
    </td>
  </tr>
);

export default KkpPlanningPageShell;
